import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import styled from '@emotion/styled';

const StyledDialog = styled.dialog`
    border-radius: 5px;
    border: none !important;
    overflow-x: auto;
    overflow-y: auto;
`;

export default function Modal({ children, open }) {
  const dialog = useRef();
  const modalContainer = useRef(document.createElement('div'));

  useEffect(() => {
    const currentModalContainer = modalContainer.current;

    document.body.appendChild(currentModalContainer);

    if (open && dialog.current) {
      dialog.current.showModal();
    } else if (dialog.current) {
      dialog.current.close();
    }


    return () => {
      if (currentModalContainer.parentNode) {
        currentModalContainer.parentNode.removeChild(currentModalContainer);
      }
    };
  }, [open]);


  return createPortal(
    <StyledDialog className="modal" ref={dialog}>
      {children}
    </StyledDialog>,
    modalContainer.current
  );
}
